(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-buyer-center"] && !Shopify.designMode) return;
  try {
    
function updateRehanBuyerRoute(section) {
  var selected = section.querySelector('[data-rs-buyer-team]:checked');
  var buyer = selected && /^[1-4]$/.test(selected.value) ? selected.value : '';
  section.querySelectorAll('[data-rs-buyer-request]').forEach(function(link) {
    var purpose = link.dataset.requestPurpose === 'specifications' ? 'specifications' : 'quote';
    var params = new URLSearchParams();
    params.set('request_type', purpose);
    if (buyer) params.set('buyer_type', buyer);
    link.href = link.dataset.requestBase + '?' + params.toString();
  });
}
function prepareRehanBuyerPrint() {
  document.querySelectorAll('[data-rs-buyer-worksheet]').forEach(function(worksheet) {
    syncRehanBuyerWorksheet(worksheet);
    worksheet.querySelectorAll('[data-rs-buyer-procurement]').forEach(function(details) {
      if (!details.open) { details.open = true; details.dataset.rsBuyerPrintOpened = 'true'; }
    });
  });
}
function restoreRehanBuyerPrint() {
  document.querySelectorAll('[data-rs-buyer-print-opened]').forEach(function(details) {
    details.open = false;
    delete details.dataset.rsBuyerPrintOpened;
  });
}

function syncRehanBuyerWorksheet(worksheet) {
  worksheet.querySelectorAll('[data-rs-buyer-value]').forEach(function(field) {
    var printed = field.parentElement.querySelector('.rs-buyer-center__printed');
    if (!printed) return;
    var value = field.value;
    if (field.tagName === 'SELECT') value = field.value ? field.options[field.selectedIndex].text : '';
    printed.textContent = value;
  });
}
function prepareRehanBuyerResources() {
  document.querySelectorAll('[data-rs-buyer-center]').forEach(function(section) {
    var worksheet = section.querySelector('[data-rs-buyer-worksheet]');
    if (!worksheet) return;
    updateRehanBuyerRoute(section);
    worksheet.setAttribute('data-rs-buyer-ready', '');
    var printButton = section.querySelector('[data-rs-buyer-print]');
    if (printButton) printButton.hidden = false;
    var rowActions = worksheet.querySelector('[data-rs-buyer-row-actions]');
    if (rowActions) rowActions.hidden = false;
    syncRehanBuyerWorksheet(worksheet);
  });
}
function updateRehanBuyerRows(worksheet) {
  var rows = Array.from(worksheet.querySelectorAll('[data-rs-buyer-row]'));
  var visible = rows.filter(function(row) { return !row.hidden; });
  worksheet.querySelector('[data-rs-buyer-add]').disabled = visible.length >= rows.length;
  worksheet.querySelector('[data-rs-buyer-remove]').disabled = visible.length <= 1;
  worksheet.querySelector('[data-rs-buyer-status]').textContent = worksheet.dataset.rowMessage.replace('__COUNT__', String(visible.length));
}
prepareRehanBuyerResources();
document.addEventListener('shopify:section:load', prepareRehanBuyerResources);
document.addEventListener('input', function(event) {
  var worksheet = event.target.closest('[data-rs-buyer-worksheet]');
  if (worksheet) syncRehanBuyerWorksheet(worksheet);
});
document.addEventListener('change', function(event) {
  if (event.target.matches('[data-rs-buyer-team]')) {
    updateRehanBuyerRoute(event.target.closest('[data-rs-buyer-center]'));
  }
  var worksheet = event.target.closest('[data-rs-buyer-worksheet]');
  if (worksheet) syncRehanBuyerWorksheet(worksheet);
});
document.addEventListener('click', function(event) {
  var printButton = event.target.closest('[data-rs-buyer-print]');
  if (printButton) {
    var section = printButton.closest('[data-rs-buyer-center]');
    prepareRehanBuyerPrint();
    window.print();
    return;
  }
  var add = event.target.closest('[data-rs-buyer-add]');
  var remove = event.target.closest('[data-rs-buyer-remove]');
  if (!add && !remove) return;
  var worksheet = (add || remove).closest('[data-rs-buyer-worksheet]');
  var rows = Array.from(worksheet.querySelectorAll('[data-rs-buyer-row]'));
  if (add) {
    var next = rows.find(function(row) { return row.hidden; });
    if (next) { next.hidden = false; next.querySelector('input').focus(); }
  } else {
    var visible = rows.filter(function(row) { return !row.hidden; });
    if (visible.length > 1) visible[visible.length - 1].hidden = true;
  }
  updateRehanBuyerRows(worksheet);
});
window.addEventListener('beforeprint', prepareRehanBuyerPrint);
window.addEventListener('afterprint', restoreRehanBuyerPrint);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-buyer-path"] && !Shopify.designMode) return;
  try {
    
function rsBuyerStarterHref(baseHref, ids, allowedIds, origin) {
  const url = new URL(baseHref, origin);
  if (url.origin !== origin) return '';
  const allowed = new Set(allowedIds);
  const selected = [...new Set(ids)].filter(id => allowed.has(id) && /^RS\d{6}-[A-Z0-9-]{1,60}$/.test(id)).slice(0,12);
  if (!selected.length) return '';
  url.searchParams.set('list_items', selected.join(','));
  return url.pathname + url.search + url.hash;
}
function rsInitializeBuyerStarters(root) {
  root.querySelectorAll('[data-buyer-starter]').forEach(panel => {
    if (panel.dataset.buyerReady) return;
    const link = panel.querySelector('[data-buyer-continue]');
    const status = panel.querySelector('[data-buyer-status]');
    const items = [...panel.querySelectorAll('[data-buyer-item]')];
    if (!link || !status || !items.length) return;
    const baseHref = link.getAttribute('href');
    const allowedIds = items.map(item => item.value);
    const refresh = () => {
      const selected = items.filter(item => item.checked).map(item => item.value);
      const href = rsBuyerStarterHref(baseHref, selected, allowedIds, window.location.origin);
      if (href) {
        link.setAttribute('href', href);
        link.removeAttribute('aria-disabled');
        link.removeAttribute('tabindex');
      } else {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('tabindex', '0');
      }
      status.textContent = selected.length ? panel.dataset.buyerCountTemplate.replace('[count]', String(selected.length)) : panel.dataset.buyerEmptyLabel;
    };
    panel.querySelectorAll('[data-buyer-choice]').forEach(label => { label.hidden = false; });
    items.forEach(item => item.addEventListener('change', refresh));
    link.addEventListener('click', event => { if (link.getAttribute('aria-disabled') === 'true') event.preventDefault(); });
    panel.dataset.buyerReady = 'true';
    refresh();
  });
}
rsInitializeBuyerStarters(document);
document.addEventListener('shopify:section:load', event => rsInitializeBuyerStarters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-chile-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const initialize = container => {
    container.querySelectorAll('[data-chile-finder]').forEach(root => {
      if (root.dataset.chileReady) return;
      root.dataset.chileReady = 'true';
      const controls = root.querySelector('[data-chile-controls]');
      const search = root.querySelector('[data-chile-search]');
      const filters = [...root.querySelectorAll('[data-chile-filter]')];
      const cards = [...root.querySelectorAll('[data-chile-card]')];
      const result = root.querySelector('[data-chile-results]');
      const clear = root.querySelector('[data-chile-clear]');
      const empty = root.querySelector('[data-chile-empty]');
      const update = () => {
        const query = normalize(search.value);
        const selected = filters.find(input => input.checked)?.value || 'all';
        let count = 0;
        let formCount = 0;
        cards.forEach(card => {
          const match = (selected === 'all' || card.dataset.kind === selected) && (!query || normalize(card.dataset.search).includes(query));
          card.hidden = !match;
          if (match) {
            count += 1;
            formCount += Number(card.dataset.forms) || 0;
          }
        });
        result.textContent = root.dataset.resultTemplate.replace('__COUNT__', String(count)).replace('__FORMS__', String(formCount));
        clear.hidden = !query && selected === 'all';
        empty.hidden = count > 0;
      };
      search.addEventListener('input', update);
      filters.forEach(input => input.addEventListener('change', update));
      clear.addEventListener('click', () => {
        search.value = '';
        filters.forEach(input => { input.checked = input.value === 'all'; });
        update();
        search.focus();
      });
      controls.hidden = false;
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

function rsChileComparisonModel(families, limit = 3) {
  const chosen = new Map();
  const valid = (handle, form) => families.has(handle) && families.get(handle).includes(form);
  return {
    add(handle) {
      if (!families.has(handle) || !families.get(handle).length) return 'invalid';
      if (chosen.has(handle)) return 'existing';
      if (chosen.size >= limit) return 'limit';
      chosen.set(handle, families.get(handle)[0]);
      return 'added';
    },
    remove(handle) { return chosen.delete(handle); },
    clear() { chosen.clear(); },
    setForm(handle, form) {
      if (!chosen.has(handle) || !valid(handle, form)) return false;
      chosen.set(handle, form);
      return true;
    },
    has(handle) { return chosen.has(handle); },
    form(handle) { return chosen.get(handle); },
    entries() { return [...chosen.entries()]; },
    count() { return chosen.size; }
  };
}
function rsChileComparisonRequestPath(request, forms, origin) {
  if (!forms.length) return '';
  const url = new URL(request, origin);
  url.searchParams.set('list_items', forms.join(','));
  return url.pathname + url.search + url.hash;
}
function rsInitChileComparison(root) {
  if (root.dataset.chileCompareReady) return;
  const dialog = root.querySelector('[data-chile-compare-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const templates = new Map([...root.querySelectorAll('template[data-chile-compare-template]')].map(template => [template.dataset.chileCompareTemplate, template]));
  const families = new Map([...templates].map(([handle, template]) => [handle, [...template.content.querySelectorAll('[data-chile-compare-form] option')].map(option => option.value)]));
  const model = rsChileComparisonModel(families);
  const choices = [...root.querySelectorAll('[data-chile-compare-choice]')];
  const tray = root.querySelector('[data-chile-compare-tray]');
  const chips = root.querySelector('[data-chile-compare-chips]');
  const grid = dialog.querySelector('[data-chile-compare-grid]');
  const empty = dialog.querySelector('[data-chile-compare-empty]');
  const quote = dialog.querySelector('[data-chile-compare-quote]');
  const status = root.querySelector('[data-chile-compare-status]');
  const openButton = root.querySelector('[data-chile-compare-open]');
  const countLabel = () => root.dataset.compareCount.replace('__COUNT__', String(model.count()));
  let returnFocus = null;
  const announce = text => { status.textContent = text; };
  const namedRemove = name => root.dataset.compareRemove.replace('__TITLE__', name);
  const updateQuote = () => {
    const ids = model.entries().map(([, form]) => form);
    quote.hidden = ids.length === 0;
    if (!ids.length) { quote.removeAttribute('href'); return; }
    quote.href = rsChileComparisonRequestPath(root.dataset.compareRequest, ids, window.location.origin);
  };
  const updateCard = card => {
    const handle = card.dataset.chileCompareCard;
    const select = card.querySelector('[data-chile-compare-form]');
    select.value = model.form(handle);
    const option = select.selectedOptions[0];
    if (!option) return;
    const retail = card.querySelector('[data-chile-compare-retail]');
    const wholesale = card.querySelector('[data-chile-compare-wholesale]');
    retail.hidden = !option.dataset.retail;
    if (option.dataset.retail) retail.href = option.dataset.retail;
    else retail.removeAttribute('href');
    wholesale.href = option.dataset.wholesale;
    const image = card.querySelector('[data-chile-compare-image]');
    const imageWrap = card.querySelector('[data-chile-compare-photo]');
    const art = card.querySelector('[data-chile-compare-art]');
    imageWrap.hidden = !option.dataset.image;
    art.hidden = Boolean(option.dataset.image);
    if (option.dataset.image) image.src = option.dataset.image;
    else image.removeAttribute('src');
  };
  const renderTray = () => {
    tray.hidden = model.count() === 0;
    root.classList.toggle('rs-cf--comparing', model.count() > 0);
    root.querySelectorAll('[data-chile-compare-count]').forEach(element => { element.textContent = countLabel(); });
    choices.forEach(choice => { choice.checked = model.has(choice.value); });
    chips.replaceChildren();
    model.entries().forEach(([handle]) => {
      const name = templates.get(handle).dataset.title;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.chileCompareRemove = handle;
      button.setAttribute('aria-label', namedRemove(name));
      const title = document.createElement('span');
      title.textContent = name;
      const icon = document.createElement('span');
      icon.textContent = '×';
      icon.setAttribute('aria-hidden', 'true');
      button.append(title, icon);
      chips.append(button);
    });
    updateQuote();
  };
  const renderDialog = () => {
    grid.replaceChildren();
    const entries = model.entries();
    grid.style.setProperty('--chile-compare-columns', String(Math.max(1, entries.length)));
    entries.forEach(([handle]) => {
      const fragment = templates.get(handle).content.cloneNode(true);
      const card = fragment.querySelector('[data-chile-compare-card]');
      updateCard(card);
      grid.append(fragment);
    });
    grid.hidden = !entries.length;
    empty.hidden = entries.length > 0;
    updateQuote();
  };
  root.addEventListener('change', event => {
    const choice = event.target.closest('[data-chile-compare-choice]');
    if (choice) {
      if (choice.checked) {
        const result = model.add(choice.value);
        if (result === 'limit') { choice.checked = false; announce(root.dataset.compareLimit); return; }
        if (result === 'invalid') { choice.checked = false; return; }
      } else model.remove(choice.value);
      renderTray();
      announce(countLabel());
      return;
    }
    const select = event.target.closest('[data-chile-compare-form]');
    if (select) {
      const card = select.closest('[data-chile-compare-card]');
      if (model.setForm(card.dataset.chileCompareCard, select.value)) { updateCard(card); updateQuote(); }
    }
  });
  root.addEventListener('click', event => {
    const open = event.target.closest('[data-chile-compare-open]');
    if (open) {
      if (!model.count()) return;
      returnFocus = open;
      renderDialog();
      dialog.showModal();
      dialog.querySelector('[data-chile-compare-title]').focus();
      return;
    }
    const remove = event.target.closest('[data-chile-compare-remove]');
    if (remove) {
      const previous = model.entries().findIndex(([handle]) => handle === remove.dataset.chileCompareRemove);
      if (!model.remove(remove.dataset.chileCompareRemove)) return;
      renderTray();
      if (dialog.open) {
        renderDialog();
        const remaining = [...grid.querySelectorAll('[data-chile-compare-remove]')];
        (remaining[Math.min(previous, remaining.length - 1)] || empty).focus();
      } else if (model.count()) {
        const remaining = [...chips.querySelectorAll('[data-chile-compare-remove]')];
        (remaining[Math.min(previous, remaining.length - 1)] || openButton).focus();
      } else {
        const choice = choices.find(input => input.value === remove.dataset.chileCompareRemove);
        if (choice && !choice.closest('[data-chile-card]').hidden) choice.focus();
        else root.querySelector('[data-chile-search]')?.focus();
      }
      announce(countLabel());
      return;
    }
    if (event.target.closest('[data-chile-compare-clear]')) {
      model.clear();
      renderTray();
      if (dialog.open) { renderDialog(); empty.focus(); }
      else root.querySelector('[data-chile-search]')?.focus();
      announce(countLabel());
    }
    if (event.target.closest('[data-chile-compare-close]')) dialog.close();
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => {
    if (returnFocus && returnFocus.isConnected && !tray.hidden) returnFocus.focus({preventScroll: true});
    else root.querySelector('[data-chile-search]')?.focus();
  });
  root.querySelectorAll('[data-chile-compare-control]').forEach(control => { control.hidden = false; });
  root.dataset.chileCompareReady = 'true';
  renderTray();
}
document.querySelectorAll('[data-chile-finder]').forEach(rsInitChileComparison);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-chile-finder]').forEach(rsInitChileComparison));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-cinema"] && !Shopify.designMode) return;
  try {
    
function rsInitCinema(root) {
  root.querySelectorAll('[data-rs-cinema]').forEach(section => {
    if (section.dataset.rsCinemaReady) return;
    section.dataset.rsCinemaReady = 'true';
    const film = section.querySelector('[data-rs-film]');
    const button = section.querySelector('[data-rs-film-toggle]');
    if (!film || !button) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let explicitlyPaused = false;
    let inView = false;
    button.hidden = false;
    const sync = () => { button.textContent = film.paused ? button.dataset.playLabel : button.dataset.pauseLabel; };
    const play = () => { const result = film.play(); if (result) result.catch(sync); };
    film.addEventListener('play', sync);
    film.addEventListener('pause', sync);
    film.addEventListener('error', () => { button.hidden = true; });
    button.addEventListener('click', () => {
      explicitlyPaused = !film.paused;
      if (film.paused) play(); else film.pause();
    });
    film.addEventListener('pause', () => { if (inView && !document.hidden) explicitlyPaused = true; });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
        if (inView && !motion.matches && !explicitlyPaused && !document.hidden) play();
        if (!inView) film.pause();
      }, { threshold: 0.2 });
      observer.observe(film);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    }
    motion.addEventListener('change', event => { if (event.matches) film.pause(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) film.pause(); });
  });
}
rsInitCinema(document);
document.addEventListener('shopify:section:load', event => rsInitCinema(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-collection"]) return;
  try {
    

  (() => {
    if (window.rsCatalogueSearchBound) return;
    window.rsCatalogueSearchBound = true;
    const buildQuery = (value) => {
      const phrase = value.trim().replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      return ['title', 'product_type', 'variants.sku'].map((field) => field + ':"' + phrase + '"').join(' OR ');
    };
    const restoreTerms = (root) => {
      const params = new URLSearchParams(window.location.search);
      const term = params.get('rs_query');
      if (term === null || params.get('q') !== buildQuery(term)) return;
      root.querySelectorAll('[data-rs-search-term]').forEach((input) => { input.value = term; });
      root.querySelectorAll('[data-rs-search-summary]').forEach((summary) => { summary.textContent = summary.dataset.rsSummaryTemplate.replace('__RS_QUERY__', term); });
    };
    restoreTerms(document);
    document.addEventListener('shopify:section:load', (event) => restoreTerms(event.target));
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-rs-catalogue-search]');
      if (!form) return;
      const input = form.querySelector('[data-rs-search-term]');
      if (!input || !input.value.trim()) return;
      let queryInput = form.querySelector('[data-rs-search-query]');
      if (!queryInput) {
        queryInput = document.createElement('input');
        queryInput.type = 'hidden';
        queryInput.name = 'q';
        queryInput.dataset.rsSearchQuery = '';
        form.append(queryInput);
      }
      input.name = 'rs_query';
      queryInput.value = buildQuery(input.value);
    });
  })();

  (() => {
    if (window.rsCatalogueSortBound) return;
    window.rsCatalogueSortBound = true;
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-rs-collection-sort]');
      if (!form) return;
      const params = new URLSearchParams(window.location.search);
      params.forEach((value, key) => {
        if (!key.startsWith('filter.') && !/^utm_(source|medium|campaign|content|term)$/.test(key) && key !== 'rs_landing') return;
        if (form.elements.namedItem(key)) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value.slice(0, 500);
        form.append(input);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-contact"] && !Shopify.designMode) return;
  try {
    
  function rsContactProductUrl(value, origin) {
    try {
      const parsed = new URL(value, origin);
      if (parsed.origin !== origin) return '';
      if (parsed.pathname === '/pages/retail-shop') {
        const ingredient = parsed.searchParams.get('ingredient') || '';
        const form = parsed.searchParams.get('form') || '';
        if (!/^[a-z0-9-]{1,150}$/.test(ingredient) || (form && !/^RS\d{6}-[A-Z0-9-]{1,60}$/.test(form))) return '';
        const clean = new URL(parsed.pathname, origin);
        clean.searchParams.set('ingredient', ingredient);
        if (form) clean.searchParams.set('form', form);
        return clean.href;
      }
      if (/^\/products\/[a-z0-9-]+\/?$/.test(parsed.pathname)) {
        ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','rs_landing'].forEach(key => parsed.searchParams.delete(key));
        return parsed.href.slice(0,1000);
      }
    } catch {}
    return '';
  }
  function rehanPrefillContact(scope) {
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product');
    const variant = params.get('variant');
    const quantity = params.get('quantity');
    const variantId = params.get('variant_id');
    const productUrl = params.get('product_url');
    scope.querySelectorAll('[data-rs-contact]').forEach((section) => {
      const feedback = section.querySelector('[data-rs-contact-feedback]');
      if (feedback) feedback.focus();
      const enquiryForm = section.querySelector('form');
      const recoveryKey = 'rehan-enquiry-recovery';
      const recoveryNames = ['contact[business]','contact[product]','contact[variant]','contact[quantity]','contact[variant_id]','contact[product_url]','contact[business_type]','contact[delivery_zip]','contact[order_frequency]','contact[enquiry_page]','contact[Request type]'];
      try {
        if (section.querySelector('.rs-contact-feedback--success')) sessionStorage.removeItem(recoveryKey);
        if (section.querySelector('.rs-contact-feedback--error')) {
          const recovery = JSON.parse(sessionStorage.getItem(recoveryKey) || 'null');
          if (enquiryForm && recovery && recovery.values && Date.now() - recovery.time >= 0 && Date.now() - recovery.time < 1800000) recoveryNames.forEach(name => { const field = enquiryForm.elements.namedItem(name); if (field && typeof recovery.values[name] === 'string') field.value = recovery.values[name].slice(0,1000); });
          sessionStorage.removeItem(recoveryKey);
        }
      } catch {}
      function fillCampaignFields() {
        if (!enquiryForm) return;
        let allowed = false;
        try { allowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; } catch {}
        const campaign = {};
        ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key => {
          const value = params.get(key);
          if (allowed && value && /^[a-zA-Z0-9_. -]{1,100}$/.test(value)) campaign[key] = value;
        });
        const landing = params.get('rs_landing');
        if (allowed && landing && /^\/[a-zA-Z0-9_\/-]{0,200}$/.test(landing) && !landing.startsWith('//')) campaign.landing_page = landing;
        else if (Object.keys(campaign).length) campaign.landing_page = window.location.pathname;
        if (!allowed) ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','landing_page'].forEach(key => {
          const field = enquiryForm.elements.namedItem('contact[' + key + ']');
          if (field) { field.value = ''; field.setAttribute('value',''); }
        });
        const productLink = enquiryForm.elements.namedItem('contact[product_url]');
        if (productLink?.value && !allowed) {
          try {
            const cleanUrl = new URL(productLink.value,window.location.origin);
            ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','rs_landing'].forEach(key => cleanUrl.searchParams.delete(key));
            productLink.value = cleanUrl.href;
            productLink.setAttribute('value',cleanUrl.href);
          } catch {}
        }
        campaign.enquiry_page = window.location.pathname;
        Object.entries(campaign).forEach(([key,value]) => {
          const field = enquiryForm.elements.namedItem('contact[' + key + ']');
          if (field) {
            if (!field.value) field.value = value;
            field.setAttribute('value', field.value);
          }
        });
        enquiryForm.dataset.rsSourceCount = String([...enquiryForm.querySelectorAll('[data-rs-source]')].filter(field => field.value).length);
      }
      fillCampaignFields();
      if (enquiryForm && !enquiryForm.dataset.rsRecoveryReady) {
        enquiryForm.dataset.rsRecoveryReady = 'true';
        document.addEventListener('visitorConsentCollected', fillCampaignFields);
        document.addEventListener('rehan:privacy-ready', fillCampaignFields);
        enquiryForm.addEventListener('submit', () => {
          fillCampaignFields();
          try { sessionStorage.setItem(recoveryKey, JSON.stringify({time:Date.now(),values:Object.fromEntries(recoveryNames.map(name => [name,enquiryForm.elements.namedItem(name)?.value || '']))})); } catch {}
        });
        enquiryForm.addEventListener('input', (event) => {
          if (!event.target.matches('[data-rs-enquiry-product],[data-rs-enquiry-variant]')) return;
          enquiryForm.querySelector('[data-rs-enquiry-variant-id]').value = '';
          enquiryForm.querySelector('[data-rs-enquiry-product-url]').value = '';
        });
      }
      const buyerField = section.querySelector('[data-rs-buyer]');
      const buyerId = params.get('buyer_type');
      if (buyerField && !feedback && !buyerField.value && /^[1-4]$/.test(buyerId || '')) {
        const option = buyerField.querySelector('[data-buyer-id="' + buyerId + '"]');
        if (option) buyerField.value = option.value;
      }
      const productField = section.querySelector('[data-rs-enquiry-product]');
      const variantField = section.querySelector('[data-rs-enquiry-variant]');
      const quantityField = section.querySelector('[data-rs-enquiry-quantity]');
      const variantIdField = section.querySelector('[data-rs-enquiry-variant-id]');
      const productUrlField = section.querySelector('[data-rs-enquiry-product-url]');
      if (productField && !feedback && !productField.value && product) productField.value = product.slice(0, 300);
      if (variantField && !feedback && !variantField.value && variant) variantField.value = variant.slice(0, 250);
      if (quantityField && !feedback && !quantityField.value && quantity) quantityField.value = quantity.slice(0, 100);
      if (!feedback && variantIdField && variantId && /^\d+$/.test(variantId)) variantIdField.value = variantId.slice(0, 30);
      if (!feedback && productUrlField && productUrl) productUrlField.value = rsContactProductUrl(productUrl, window.location.origin);
      const enquiryType = section.querySelector('[data-rs-enquiry-type]');
      if (enquiryType) {
        if (!feedback && params.get('enquiry_type') === 'retail') enquiryType.value = enquiryType.dataset.retailLabel;
        const retail = enquiryType.value === enquiryType.dataset.retailLabel;
        if (!retail) enquiryType.value = '';
        const context = section.querySelector('[data-rs-retail-context]');
        if (context) context.hidden = !retail;
        const heading = section.querySelector('[data-rs-contact-heading]');
        if (retail && heading) heading.textContent = heading.dataset.retailHeading;
      }
      const purchasing = section.querySelector('[data-contact-purchasing]');
      if (purchasing && [...purchasing.querySelectorAll('input,select')].some(field => field.value)) purchasing.open = true;
    });
  }
  rehanPrefillContact(document);
  document.addEventListener('shopify:section:load', (event) => rehanPrefillContact(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-header"] && !Shopify.designMode) return;
  try {
    
function rehanMarketNavigation(root) {
  root.querySelectorAll('[data-rs-market-header]').forEach(header => {
    if (header.dataset.marketReady) return;
    header.dataset.marketReady = 'true';
    const topMenus = Array.from(header.querySelectorAll('[data-rs-market-dropdown], [data-rs-market-mobile]'));
    header.querySelectorAll('details').forEach(menu => menu.addEventListener('toggle', () => {
      if (!menu.open || !menu.parentElement) return;
      Array.from(menu.parentElement.children).forEach(sibling => {
        if (sibling !== menu && sibling.tagName === 'DETAILS') sibling.open = false;
      });
    }));
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const menu = event.target.closest('details[open]');
      if (!menu || !header.contains(menu)) return;
      event.preventDefault(); event.stopPropagation(); menu.open = false;
      const summary = menu.querySelector(':scope > summary');
      if (summary) summary.focus();
    });
    document.addEventListener('click', event => {
      topMenus.forEach(menu => { if (menu.open && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false; });
    });
    header.addEventListener('focusout', event => {
      const next = event.relatedTarget;
      if (next && !header.contains(next)) topMenus.forEach(menu => { menu.open = false; });
    });
  });
}
rehanMarketNavigation(document);
document.addEventListener('shopify:section:load', event => rehanMarketNavigation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-line-card"] && !Shopify.designMode) return;
  try {
    
function prepareRehanLineCard() {
  document.querySelectorAll('[data-rs-line-card-print]').forEach(function(button) { button.hidden = false; });
}
prepareRehanLineCard();
document.addEventListener('shopify:section:load', prepareRehanLineCard);
document.addEventListener('click', function(event) {
  if (event.target.closest('[data-rs-line-card-print]')) window.print();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-order-request"] && !Shopify.designMode) return;
  try {
    
  function rsRequestIdValid(id) {
    return typeof id === 'string' && (/^[1-9]\d{0,19}$/.test(id) || /^RS\d{6}-[A-Z0-9-]{1,60}$/.test(id));
  }
  function rsRequestClearSubmitted(getStorage, now) {
    try {
      const storage = getStorage();
      const raw = storage.getItem('rehan-wholesale-request-items-v1');
      const saved = typeof raw === 'string' && raw.length <= 10000 ? JSON.parse(raw) : null;
      storage.removeItem('rehan-wholesale-request-items-v1');
      if (!saved || !Array.isArray(saved.items) || !Number.isFinite(saved.time) || now - saved.time < 0 || now - saved.time >= 1800000) return [];
      const submitted = [...new Set(saved.items.slice(0,12).map(item => item?.variant).filter(rsRequestIdValid))];
      for (const key of ['rehan-ingredient-list-v1','rehan-ingredient-list-v2']) {
        const listRaw = storage.getItem(key);
        if (typeof listRaw !== 'string' || listRaw.length > 5000) continue;
        try {
          const list = JSON.parse(listRaw);
          if (![1,2].includes(list?.version) || !Array.isArray(list.ids)) continue;
          list.ids = list.ids.filter(id => !submitted.includes(id));
          storage.setItem(key,JSON.stringify(list));
        } catch {}
      }
      return submitted;
    } catch { return []; }
  }
  function rsRequestPurpose(params, hasFeedback, serverValue, recoveredValue) {
    const allowed = value => ['quote','specifications'].includes(value) ? value : '';
    if (hasFeedback) return allowed(serverValue) || allowed(recoveredValue) || 'quote';
    return allowed(params.get('request_type')) || allowed(serverValue) || 'quote';
  }
  function rsRequestProductVariant(params, catalogueOptions) {
    const options = [...catalogueOptions].filter(option => option.dataset.productId || option.dataset.catalogueId);
    const variant = params.get('variant_id');
    if (variant !== null) return options.some(option => option.value === variant) ? variant : '';
    const handle = params.get('product') || '';
    if (handle.length > 100 || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)) return '';
    const matches = options.filter(option => option.dataset.productHandle === handle);
    return matches.length === 1 ? matches[0].value : '';
  }
  function rsRequestAmountValid(values, purpose) {
    if (purpose === 'specifications' && !values.quantity && !values.unit) return true;
    const quantity = Number(values.quantity);
    return Number.isFinite(quantity) && quantity > 0 && quantity <= 1000000000 && ['lb','kg','bags','cases','boxes'].includes(values.unit);
  }
  function rsListRequestRows(params, catalogueOptions) {
    const mixed = params.has('list_items');
    if (!mixed && params.get('from_list') !== '1') return null;
    const value = params.get(mixed ? 'list_items' : 'list_variants') || '';
    if (!value || value.length > (mixed ? 900 : 251)) return {rows:[], partial:true};
    const parts = value.split(',');
    if (parts.length > 12) return {rows:[], partial:true};
    const allowed = new Set([...catalogueOptions].filter(option => option.dataset.productId || option.dataset.catalogueId).map(option => option.value));
    const ids = [...new Set(parts)];
    const valid = ids.filter(id => (mixed ? rsRequestIdValid(id) : /^[1-9]\d{0,19}$/.test(id)) && allowed.has(id));
    return {rows:valid.map(variant => ({variant,quantity:'',unit:'',pack:''})), partial:valid.length !== ids.length};
  }
  function rsRecipeRequestRows(params, catalogueOptions) {
    const value = params.get('ingredient_handles');
    if (!value || value.length > 1200) return [];
    const parts = value.split(',');
    if (parts.length > 12) return [];
    const handles = [...new Set(parts.map(handle => handle.trim()).filter(handle => handle.length <= 100 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)))];
    const options = [...catalogueOptions];
    const selected = [];
    for (const handle of handles) {
      const matches = options.filter(option => option.dataset.productHandle === handle);
      const option = handle === 'cinnamon-korintji' ? matches.find(candidate => /\bground\b/i.test(candidate.dataset.variantTitle || '')) : matches[0];
      if (!option || !/^\d+$/.test(option.value)) continue;
      selected.push({variant:option.value,quantity:'',unit:'',pack:''});
      if (selected.length === 4) break;
    }
    return selected;
  }
  function rsInitializeWholesaleRequests(root) {
    root.querySelectorAll('[data-rs-order-request]').forEach((section) => {
      if (section.dataset.rsRequestReady) return;
      section.dataset.rsRequestReady = 'true';
      const recoveryKey = 'rehan-wholesale-request-items-v1';
      const feedback = section.querySelector('[data-rs-request-feedback]');
      if (feedback) feedback.focus();
      if (section.querySelector('[data-rs-request-success]')) {
        const submitted = rsRequestClearSubmitted(() => sessionStorage,Date.now());
        if (submitted.length) document.dispatchEvent(new CustomEvent('rs:selection-submitted',{detail:{ids:submitted}}));
        return;
      }
      const form = section.querySelector('form');
      const params = new URLSearchParams(window.location.search);
      const purpose = section.querySelector('[data-rs-request-purpose]');
      let recovery = null;
      let recoveredPurpose = '';
      let recoveredBuyerType = '';
      if (section.querySelector('[data-rs-request-server-error]')) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(recoveryKey) || 'null');
          if (saved && Date.now() - saved.time >= 0 && Date.now() - saved.time < 1800000 && Array.isArray(saved.items)) {
            recovery = saved.items.slice(0,12);
            recoveredPurpose = saved.purpose;
            recoveredBuyerType = typeof saved.buyerType === 'string' ? saved.buyerType.slice(0,200) : '';
          }
          sessionStorage.removeItem(recoveryKey);
        } catch {}
      }
      if (purpose) purpose.value = rsRequestPurpose(params, Boolean(feedback), purpose.dataset.rsServerPurpose, recoveredPurpose);
      const recoveredBuyer = section.querySelector('[data-rs-request-buyer]');
      if (recoveredBuyer && recoveredBuyerType && [...recoveredBuyer.options].some(option => option.value === recoveredBuyerType)) recoveredBuyer.value = recoveredBuyerType;
      const template = section.querySelector('[data-rs-request-row-template]');
      const rows = section.querySelector('[data-rs-request-rows]');
      const fallback = section.querySelector('[data-rs-request-fallback]');
      const serialized = section.querySelector('[data-rs-request-serialized]');
      const enhanced = section.querySelector('[data-rs-request-enhanced]');
      const addButton = section.querySelector('[data-rs-request-add]');
      const status = section.querySelector('[data-rs-request-status]');
      const error = section.querySelector('[data-rs-request-error]');
      if (!form || !template || !rows || !serialized || template.content.querySelectorAll('option[data-product-id],option[data-catalogue-id]').length === 0) return;
      let sequence = 0;
      const getRows = () => [...rows.querySelectorAll('[data-rs-request-row]')];
      const field = (row, name) => row.querySelector('[data-rs-row-field="' + name + '"]');
      const labels = section.dataset;
      const catalogueIds = new Set([...template.content.querySelectorAll('option[data-product-id],option[data-catalogue-id]')].map(option => option.value));
      function renumber() {
        const current = getRows();
        current.forEach((row, index) => {
          row.querySelector('[data-rs-request-legend]').textContent = labels.rsItemLabel + ' ' + (index + 1);
          row.querySelector('[data-rs-request-remove]').setAttribute('aria-label', labels.rsRemoveLabel + ' ' + (index + 1));
          row.querySelector('[data-rs-request-remove]').disabled = current.length === 1;
        });
        addButton.disabled = current.length >= 12;
      }
      function setPackRequirement(row) {
        const amountRequired = purpose?.value !== 'specifications' || Boolean(field(row,'quantity').value.trim() || field(row,'unit').value);
        field(row,'quantity').required = amountRequired;
        field(row,'unit').required = amountRequired;
        row.querySelectorAll('[data-rs-amount-star]').forEach(star => { star.hidden = !amountRequired; });
        const required = ['bags','cases','boxes'].includes(field(row,'unit').value);
        field(row,'pack').required = required;
        row.querySelector('[data-rs-pack-star]').hidden = !required;
        field(row,'pack').setCustomValidity(required && !field(row,'pack').value.trim() ? labels.rsPackRequired : '');
      }
      function addRow(values, focus) {
        if (getRows().length >= 12) { status.textContent = labels.rsLimit; return; }
        const row = template.content.firstElementChild.cloneNode(true);
        row.dataset.rsRequestRow = 'true';
        const base = labels.rsFormId + '-item-' + (++sequence);
        ['variant','quantity','unit','pack'].forEach((name) => {
          const input = field(row,name);
          input.id = base + '-' + name;
          row.querySelector('[data-rs-label-for="' + name + '"]').htmlFor = input.id;
          if (values && typeof values[name] === 'string') input.value = values[name].slice(0,100);
        });
        row.querySelector('[data-rs-pack-hint]').id = base + '-pack-help';
        field(row,'pack').setAttribute('aria-describedby', base + '-pack-help');
        rows.append(row);
        if (window.RehanRequestPicker) window.RehanRequestPicker.attach(row);
        setPackRequirement(row);
        renumber();
        serializeRows();
        if (focus) { field(row,'variant').focus(); status.textContent = labels.rsAdded + ' ' + getRows().length; }
      }
      function captureRows() {
        return getRows().map(row => Object.fromEntries(['variant','quantity','unit','pack'].map(name => [name,field(row,name).value.trim()])));
      }
      function serializeRows() {
        serialized.value = getRows().map((row,index) => {
          const option = field(row,'variant').selectedOptions[0];
          const title = option?.dataset.productTitle || '';
          const variant = option?.dataset.variantTitle || '';
          const details = [(index + 1) + '. ' + title + (variant ? ' — ' + variant : '')];
          if (field(row,'quantity').value || field(row,'unit').value) details.push(labels.rsQuantityLabel + ': ' + field(row,'quantity').value + ' ' + field(row,'unit').value);
          if (field(row,'pack').value.trim()) details.push(labels.rsPackLabel + ': ' + field(row,'pack').value.trim());
          details.push(labels.rsVariantLabel + ': ' + field(row,'variant').value);
          return details.join('\n');
        }).join('\n\n');
        section.dispatchEvent(new CustomEvent('rs:request-items-updated'));
      }
      if (feedback && (!recovery || !recovery.length) && serialized.value.trim()) {
        enhanced.hidden = true;
        fallback.hidden = false;
        serialized.required = true;
        return;
      }
      if (recovery && recovery.length) recovery.forEach(value => addRow(value,false));
      else {
        const listImport = !feedback ? rsListRequestRows(params, template.content.querySelectorAll('option[data-product-id],option[data-catalogue-id]')) : null;
        if (listImport) {
          if (listImport.rows.length) listImport.rows.forEach(value => addRow(value,false));
          else addRow(null,false);
          const listNotice = section.querySelector('[data-rs-request-list-notice]');
          if (listNotice) {
            listNotice.textContent = listImport.rows.length ? (listImport.partial ? listNotice.dataset.partial : listNotice.dataset.imported) : listNotice.dataset.empty;
            listNotice.hidden = false;
          }
        } else if (!feedback && params.has('ingredient_handles')) {
          const recipeRows = rsRecipeRequestRows(params, template.content.querySelectorAll('option[data-product-handle]'));
          if (recipeRows.length) {
            recipeRows.forEach(value => addRow(value,false));
            const recipeNotice = section.querySelector('[data-rs-request-recipe-notice]');
            if (recipeNotice) recipeNotice.hidden = false;
          } else addRow(null,false);
        } else {
          const values = {variant:!feedback ? rsRequestProductVariant(params, template.content.querySelectorAll('option[data-product-id],option[data-catalogue-id]')) : '',quantity:'',unit:'',pack:''};
          const quantityText = !feedback && purpose?.value !== 'specifications' ? (params.get('quantity') || '').trim() : '';
          const match = quantityText.match(/^(\d+(?:\.\d+)?)\s*(lb|kg)$/i);
          if (match) {
            values.quantity = match[1];
            const unit = (match[2] || '').toLowerCase();
            values.unit = unit;
          } else if (quantityText) {
            const notes = form.elements.namedItem('contact[body]');
            if (notes && !notes.value) notes.value = labels.rsQuantityLabel + ': ' + quantityText.slice(0,100);
          }
          addRow(values,false);
        }
      }
      enhanced.hidden = false;
      fallback.hidden = true;
      serialized.required = false;
      if (!feedback) {
        const buyerId = new URLSearchParams(window.location.search).get('buyer_type');
        const buyerField = section.querySelector('[data-rs-request-buyer]');
        if (buyerField && /^[1-4]$/.test(buyerId || '')) {
          const option = buyerField.querySelector('[data-buyer-id="' + buyerId + '"]');
          if (option) buyerField.value = option.value;
        }
      }
      purpose?.addEventListener('change', () => {
        getRows().forEach(setPackRequirement);
        serializeRows();
        error.hidden = true;
      });
      addButton.addEventListener('click', () => addRow(null,true));
      rows.addEventListener('click', (event) => {
        const button = event.target.closest('[data-rs-request-remove]');
        if (!button || getRows().length <= 1) return;
        const row = button.closest('[data-rs-request-row]');
        const current = getRows();
        const index = current.indexOf(row);
        const next = current[index + 1] || current[index - 1];
        row.remove();
        renumber();
        serializeRows();
        field(next,'variant').focus();
        status.textContent = labels.rsRemoved;
      });
      rows.addEventListener('input', (event) => {
        const row = event.target.closest('[data-rs-request-row]');
        if (row) { setPackRequirement(row); serializeRows(); error.hidden = true; }
      });
      rows.addEventListener('change', (event) => {
        const row = event.target.closest('[data-rs-request-row]');
        if (row) { setPackRequirement(row); serializeRows(); error.hidden = true; }
      });
      section.rsIngredientPlanBridge = {
        capture: captureRows,
        replace: (items) => {
          rows.replaceChildren();
          items.forEach(values => addRow(values, false));
          error.hidden = true;
          serializeRows();
        }
      };
      if (window.RehanRequestPlan) window.RehanRequestPlan.attach(section);
      document.dispatchEvent(new CustomEvent('rs:request-ready', { detail: { section } }));
      form.addEventListener('submit', (event) => {
        const current = getRows();
        current.forEach(setPackRequirement);
        const valid = current.length > 0 && current.length <= 12 && current.every(row => {
          const select = field(row,'variant');
          const values = {quantity:field(row,'quantity').value.trim(),unit:field(row,'unit').value};
          return rsRequestIdValid(select.value) && catalogueIds.has(select.value) && rsRequestAmountValid(values, purpose?.value) && field(row,'pack').checkValidity();
        });
        if (!valid || !form.checkValidity()) {
          event.preventDefault();
          error.textContent = labels.rsInvalid;
          error.hidden = false;
          form.reportValidity();
          return;
        }
        serializeRows();
        try { sessionStorage.setItem(recoveryKey, JSON.stringify({time:Date.now(),items:captureRows(),purpose:purpose?.value || 'quote',buyerType:section.querySelector('[data-rs-request-buyer]')?.value || ''})); } catch {}
      });
    });
  }
  rsInitializeWholesaleRequests(document);
  document.addEventListener('shopify:section:load', event => rsInitializeWholesaleRequests(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-pairings"] && !Shopify.designMode) return;
  try {
    
(() => {
  const words = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().match(/[\p{L}\p{N}]+(?:[./][\p{L}\p{N}]+)*/gu) || [];
  const pairingMatches = (text, application, query, chosenApplication) => {
    if (chosenApplication && application !== chosenApplication) return false;
    if (!String(query || '').trim()) return true;
    const terms = words(query);
    const source = words(text);
    return terms.length > 0 && terms.every(term => source.some(word => word.startsWith(term)));
  };
  const initialize = container => container.querySelectorAll('[data-rs-pairings]').forEach(root => {
    const filters = root.querySelector('[data-rs-pairing-filters]');
    if (!filters || root.dataset.pairingsReady) return;
    root.dataset.pairingsReady = 'true';
    const search = root.querySelector('[data-rs-pairing-search]');
    const use = root.querySelector('[data-rs-pairing-use]');
    const cards = [...root.querySelectorAll('[data-rs-pairing-card]')];
    const update = () => {
      let count = 0;
      cards.forEach(card => {
        const show = pairingMatches(card.textContent,card.dataset.application,search.value,use.value);
        card.hidden = !show;
        if (show) count += 1;
      });
      root.querySelector('[data-rs-pairing-count]').textContent = root.dataset.countTemplate.replace('[count]',String(count));
      root.querySelector('[data-rs-pairing-empty]').hidden = count > 0;
    };
    search.addEventListener('input',update);
    use.addEventListener('change',update);
    root.querySelectorAll('[data-rs-pairing-reset]').forEach(button => button.addEventListener('click',() => {search.value='';use.value='';update();search.focus();}));
    filters.hidden = false;
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(document),{once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-product"]) return;
  try {
    
  function rsUpdateProductRequestLinks(productSection) {
    const request = productSection.querySelector('[data-rs-product-request]');
    if (!request) return;
    const selector = productSection.querySelector('[data-rs-variant-select]');
    const variantId = selector?.value || request.dataset.variantId || '';
    if (!/^\d+$/.test(variantId)) return;
    const quantity = (productSection.querySelector('[data-rs-quantity]')?.value || '').trim().slice(0,100);
    productSection.querySelectorAll('[data-rs-product-request]').forEach(link => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant_id', variantId);
      if (quantity && url.searchParams.get('request_type') !== 'specifications') url.searchParams.set('quantity', quantity);
      else url.searchParams.delete('quantity');
      link.href = url.pathname + url.search;
      link.dataset.variantId = variantId;
    });
  }
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-rs-quantity]')) return;
    const productSection = event.target.closest('[data-rs-product]');
    if (!productSection) return;
    rsUpdateProductRequestLinks(productSection);
    const quote = productSection.querySelector('[data-rs-enquire]');
    if (quote) {
      const url = new URL(quote.href, window.location.origin);
      if (event.target.value.trim()) url.searchParams.set('quantity',event.target.value.trim()); else url.searchParams.delete('quantity');
      quote.href = url.pathname + url.search;
      quote.dataset.quantity = event.target.value.trim();
    }
    const builder = event.target.closest('[data-rs-product]').querySelector('[data-rs-build-request]');
    if (builder) {
      const builderUrl = new URL(builder.href, window.location.origin);
      if (event.target.value.trim()) builderUrl.searchParams.set('quantity',event.target.value.trim()); else builderUrl.searchParams.delete('quantity');
      builder.href = builderUrl.pathname + builderUrl.search;
    }
  });
  function rsInitializeProductSelectors(root) {
    root.querySelectorAll('[data-rs-product]').forEach(rsUpdateProductRequestLinks);
    root.querySelectorAll('[data-rs-variant-apply]').forEach((button) => { button.hidden = true; });
  }
  rsInitializeProductSelectors(document);
  document.addEventListener('shopify:section:load', (event) => rsInitializeProductSelectors(event.target));
  document.addEventListener('change', (event) => {
    const selector = event.target.closest('[data-rs-variant-select]');
    if (!selector) return;
    const productSection = selector.closest('[data-rs-product]');
    const option = selector.selectedOptions[0];
    if (!productSection || !option) return;
    rsUpdateProductRequestLinks(productSection);
    const availability = productSection.querySelector('[data-rs-product-availability]');
    if (availability) availability.hidden = option.dataset.available === 'true';
    const productUrl = new URL(window.location.href);
    productUrl.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', productUrl);
    const quote = productSection.querySelector('[data-rs-enquire]');
    const builder = productSection.querySelector('[data-rs-build-request]');
    if (builder) {
      const builderUrl = new URL(builder.href, window.location.origin);
      builderUrl.searchParams.set('variant_id', option.value);
      builder.href = builderUrl.pathname + builderUrl.search;
    }
    productSection.querySelectorAll('[data-rs-specification-enquiry]').forEach(specifications => {
      const specificationUrl = new URL(specifications.href, window.location.origin);
      specificationUrl.searchParams.set('variant_id', option.value);
      specifications.href = specificationUrl.pathname + specificationUrl.search;
    });
    if (quote) {
      quote.dataset.variantId = option.value;
      quote.dataset.variantTitle = option.dataset.title;
      quote.dataset.productUrl = productUrl.pathname + productUrl.search;
      const quoteUrl = new URL(quote.href, window.location.origin);
      quoteUrl.searchParams.set('variant', option.dataset.title);
      quoteUrl.searchParams.set('variant_id', option.value);
      quoteUrl.searchParams.set('product_url', productUrl.pathname + productUrl.search);
      quote.href = quoteUrl.pathname + quoteUrl.search;
    }
    if (option.dataset.mediaId) {
      const media = productSection.querySelector('[data-rs-media-id="' + option.dataset.mediaId + '"]');
      if (media) {
        productSection.querySelectorAll('[data-rs-media-id]').forEach((item) => item.style.setProperty('--rs-media-order', item === media ? '0' : '1'));
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-recipe"]) return;
  try {
    
(()=>{function initializeRecipes(){document.querySelectorAll('[data-rs-recipe]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const select=root.querySelector('[data-rs-recipe-scale]');function updateAmounts(announce){const portions=Number(select.value);if(![10,25,50].includes(portions))return;root.querySelectorAll('[data-rs-amount-10]').forEach(el=>{const text=el.getAttribute('data-rs-amount-'+portions);if(text)el.textContent=text});root.querySelector('[data-rs-recipe-yield]').textContent=root.dataset.yieldMessage.replace('[count]',String(portions));if(announce)root.querySelector('[data-rs-recipe-status]').textContent=root.dataset.scaleMessage.replace('[count]',String(portions))}select.addEventListener('change',()=>updateAmounts(true));updateAmounts(false);root.querySelector('[data-rs-recipe-print]').addEventListener('click',()=>window.print());root.querySelector('[data-rs-recipe-toolbar]').hidden=false})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeRecipes,{once:true});else initializeRecipes();document.addEventListener('shopify:section:load',initializeRecipes)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-retail-product"]) return;
  try {
    
document.addEventListener('change', event => {
  const select = event.target.closest('[data-rs-retail-variant]');
  if (!select) return;
  const root = select.closest('[data-rs-retail-product]');
  const option = select.selectedOptions[0];
  if (!root || !option) return;
  const available = root.dataset.retailAuthorized === 'true' && option.dataset.available === 'true' && option.dataset.priced === 'true';
  const price = root.querySelector('[data-rs-retail-price]');
  const button = root.querySelector('[data-rs-retail-add]');
  const status = root.querySelector('[data-rs-retail-status]');
  const quote = root.querySelector('[data-rs-retail-quote]');
  if (price && option.dataset.priced === 'true') price.textContent = option.dataset.price;
  if (button) { button.disabled = !available; button.textContent = available ? button.dataset.labelAvailable : button.dataset.labelUnavailable; }
  if (status) status.textContent = available ? status.dataset.labelAvailable : status.dataset.labelUnavailable;
  if (quote) {
    const quoteUrl = new URL(quote.href, window.location.href);
    quoteUrl.searchParams.set('variant', option.dataset.form || '');
    quote.href = quoteUrl.toString();
  }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
});
document.addEventListener('submit', event => {
  const root = event.target.closest('[data-rs-retail-product]');
  if (!root) return;
  const select = event.target.querySelector('[data-rs-retail-variant]');
  const option = select && select.selectedOptions[0];
  if (!option || root.dataset.retailAuthorized !== 'true' || option.dataset.available !== 'true' || option.dataset.priced !== 'true') event.preventDefault();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-retail-shop"] && !Shopify.designMode) return;
  try {
    
(()=>{
const roots=document.querySelectorAll('[data-retail-studio]');
roots.forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const q=s=>root.querySelector(s), qs=s=>[...root.querySelectorAll(s)], dictionary=JSON.parse(q('[data-copy]').textContent), t=k=>String(dictionary[k]||k).replace(/&(amp|lt|gt|quot|#39|#x27);/g,(_,entity)=>({amp:'&',lt:'<',gt:'>',quot:'"','#39':"'",'#x27':"'"}[entity]));
 const wholesale=root.dataset.channel==='wholesale', preview=!wholesale&&root.dataset.preview==='true', native=!wholesale&&root.dataset.native==='true';
 let products=[],basket=[],selected=null,lastFocus=null,visibleCount=24;
 const grid=q('[data-grid]'), search=q('[data-search]'), category=q('[data-category]'), formFilter=q('[data-form-filter]'), detail=q('[data-product-dialog]'), basketDialog=q('[data-basket-dialog]');
 const text=(tag,value,cls)=>{let e=document.createElement(tag);e.textContent=value;if(cls)e.className=cls;return e};
 const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(cents/100);
 const clean=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
 function matchesCatalogueQuery(value,query){const words=value=>clean(value).match(/[\p{L}\p{N}]+(?:[./][\p{L}\p{N}]+)*/gu)||[];const source=words(value),terms=words(query);return !query.trim()||(terms.length>0&&terms.every(term=>source.some(word=>word.startsWith(term))));}
 const variants=p=>p.variants||[];
 const canRetail=v=>Boolean(v&&v.price_cents>0&&!v.quote_only&&(preview||(native&&v.id)));
 const minPrice=(p,type='')=>Math.min(...variants(p).filter(v=>!type||catalogueFormType(v.form)===type).map(v=>v.price_cents).filter(n=>n>0));
 const forms=p=>[...new Set(variants(p).map(v=>v.form))];
 const formFacets=[{key:'whole',test:/\bwhole\b/},{key:'ground',test:/\b(?:ground|powder|flour)\b/},{key:'crushed',test:/\b(?:cracked|crushed|flakes)\b/},{key:'cut',test:/\b(?:cut|chopped|minced|diced|shredded)\b/},{key:'granulated',test:/\bgranulated\b/},{key:'blends',test:/\bblend\b/},{key:'other',test:null}];
 function catalogueFormType(value){return formFacets.find(facet=>facet.test?.test(clean(value||'')))?.key||'other';}
 function catalogueState(overrides={}){return {query:search.value.trim(),category:category.value,formType:formFilter.value,...overrides};}
 function catalogueMatches(p,state=catalogueState()){return (!state.category||p.category===state.category)&&(!state.formType||variants(p).some(v=>catalogueFormType(v.form)===state.formType))&&matchesCatalogueQuery([p.title,...(p.aliases||[]),...forms(p)].join(' '),state.query);}
 function filteredCatalogue(overrides={}){const state=catalogueState(overrides);return products.filter(p=>catalogueMatches(p,state));}
 function matchingCatalogueForms(p){return [...new Set(variants(p).filter(v=>!formFilter.value||catalogueFormType(v.form)===formFilter.value).map(v=>v.form))];}
 function populateFormFilters(){formFilter.replaceChildren(text('option',t('form_filter_all')));formFilter.firstChild.value='';formFacets.filter(facet=>products.some(p=>variants(p).some(v=>catalogueFormType(v.form)===facet.key))).forEach(facet=>{const option=text('option',t('form_filter_'+facet.key));option.value=facet.key;formFilter.append(option);});formFilter.disabled=false;}
 function updateFormCounts(){[...formFilter.options].forEach(option=>{if(!option.value)return;const count=filteredCatalogue({formType:option.value}).length;option.textContent=t('form_filter_'+option.value)+' ('+count+')';option.disabled=count===0&&option.value!==formFilter.value;});}
 function renderFilterChips(){const wrap=q('[data-active-filters]'),list=q('[data-filter-chips]');list.replaceChildren();const filters=[{key:'query',value:search.value.trim(),label:t('filter_chip_search'),field:search},{key:'category',value:category.value,label:t('filter_chip_category'),field:category},{key:'formType',value:formFilter.value?t('form_filter_'+formFilter.value):'',label:t('filter_chip_form'),field:formFilter}].filter(filter=>filter.value);filters.forEach((filter,index)=>{const item=text('li',''),button=text('button','','rt-filter-chip'),label=filter.label+': '+filter.value;button.type='button';button.dataset.filterKey=filter.key;button.setAttribute('aria-label',t('filter_remove').replace('{filter}',label));button.append(text('span',label));const cross=text('span','×');cross.setAttribute('aria-hidden','true');button.append(cross);button.addEventListener('click',()=>{filter.field.value='';filterChanged();const next=list.querySelectorAll('button');(next[Math.min(index,next.length-1)]||filter.field).focus();});item.append(button);list.append(item);});wrap.hidden=!filters.length;}
 function catalogueBrowseUrl(overrides={}){const state=catalogueState(overrides),url=new URL(location.href);for(const [key,value] of [['q',state.query],['category',state.category],['form_type',state.formType],['sort','az']]){if(value)url.searchParams.set(key,value);else url.searchParams.delete(key);}url.searchParams.delete('ingredient');url.searchParams.delete('form');url.hash=q('[data-catalogue-section]').id;return url.href;}
 function renderEmptyResults(){const query=search.value.trim(),message=query?t('empty_search_message').replace('{query}',query):t('empty_filter_message');q('[data-empty-message]').textContent=message;const broader=q('[data-empty-broaden]'),withoutForm=filteredCatalogue({formType:''});broader.hidden=!formFilter.value||!withoutForm.length;if(!broader.hidden){broader.href=catalogueBrowseUrl({formType:''});broader.textContent=t('empty_all_forms')+' ('+withoutForm.length+')';}const matchingElsewhere=filteredCatalogue({category:''}),preserve=matchingElsewhere.length>0,candidates=preserve?matchingElsewhere:products,counts=new Map();candidates.forEach(p=>counts.set(p.category,(counts.get(p.category)||0)+1));const entries=[...counts].sort((a,b)=>(!preserve?Number(b[0]===category.value)-Number(a[0]===category.value):0)||b[1]-a[1]||a[0].localeCompare(b[0])).slice(0,3),paths=q('[data-empty-paths]');paths.replaceChildren();entries.forEach(([name,count])=>{const link=text('a','','rt-empty-path');link.href=catalogueBrowseUrl({category:name,...(preserve?{}:{query:'',formType:''})});const copy=text('span','');copy.append(text('strong',name),text('small',count+' '+t(count===1?'product_count':'products_count')));const arrow=text('span','↗');arrow.setAttribute('aria-hidden','true');link.append(copy,arrow);paths.append(link);});}
 function resetCatalogue(){search.value='';category.value='';formFilter.value='';q('[data-sort]').value='featured';filterChanged();search.focus();}

 function quoteUrl(p,v){if(wholesale&&v?.catalogue_id){const url=new URL(root.dataset.requestUrl||'/pages/wholesale-request',location.origin);url.searchParams.set('list_items',v.catalogue_id);return url.href;}const url=new URL(root.dataset.quoteUrl||'/pages/contact',location.origin);url.searchParams.set('product',p.title);if(v?.form&&!v.form.startsWith('Ask about'))url.searchParams.set('variant',v.form);return url.href;}
 function retailQuestionUrl(p,v){const url=new URL(root.dataset.quoteUrl||'/pages/contact',location.origin),source=new URL('/pages/retail-shop',url.origin);url.search='';url.searchParams.set('enquiry_type','retail');url.searchParams.set('product',p.title);if(v?.form&&!v.form.startsWith('Ask about'))url.searchParams.set('variant',v.form);source.searchParams.set('ingredient',p.handle);if(v?.catalogue_id)source.searchParams.set('form',v.catalogue_id);url.searchParams.set('product_url',source.href);return url.href;}
 function ingredientUrl(p,v){const url=new URL(location.href);url.searchParams.set('ingredient',p.handle);if(v?.catalogue_id)url.searchParams.set('form',v.catalogue_id);else url.searchParams.delete('form');return url;}
 function syncIngredientUrl(){if(selected)history.replaceState(null,'',ingredientUrl(selected,chosen()));}
 function clearIngredientUrl(){const url=new URL(location.href);url.searchParams.delete('ingredient');url.searchParams.delete('form');history.replaceState(null,'',url);}
 function renderIngredientNotes(p){const copy=p.editorial||{},ideas=Array.isArray(copy.use_ideas)?copy.use_ideas:[];q('[data-modal-intro]').textContent=copy.intro||'';q('[data-modal-intro]').hidden=!copy.intro;q('[data-use-ideas]').replaceChildren(...ideas.map(idea=>text('li',idea)));q('[data-ideas-wrap]').hidden=!ideas.length;q('[data-buying-wrap]').hidden=!wholesale||!copy.buying_note;q('[data-buying-note]').textContent=copy.buying_note||'';q('[data-ingredient-notes]').hidden=!ideas.length&&(!wholesale||!copy.buying_note);qs('[data-ingredient-notes] details').forEach(d=>d.open=wholesale?d.hasAttribute('data-buying-wrap'):d.hasAttribute('data-ideas-wrap'));const guide=q('[data-guide-link]');guide.hidden=!copy.guide_path;if(copy.guide_path?.startsWith('/pages/'))guide.href=new URL(copy.guide_path,new URL(root.dataset.quoteUrl||'/pages/contact',location.origin)).href;else guide.hidden=true;renderPairingLinks(p);}
 function renderPairingLinks(p){const wrap=q('[data-pairing-inspiration]'),list=q('[data-pairing-links]'),seen=new Set(),items=Array.isArray(p.editorial?.pairings)?p.editorial.pairings:[];list.replaceChildren();items.forEach(item=>{if(!item||typeof item.title!=='string'||!item.title.trim()||typeof item.path!=='string'||!/^\/pages\/spice-pairings#Pairing-[a-z-]+$/.test(item.path)||seen.has(item.path))return;seen.add(item.path);const link=text('a',item.title);link.href=new URL(item.path,new URL(root.dataset.quoteUrl||'/pages/contact',location.origin)).href;const arrow=text('span','↗');arrow.setAttribute('aria-hidden','true');link.append(arrow);list.append(link);});wrap.hidden=!list.children.length;}
 function relatedProducts(p){const seen=new Set([p.handle]);return products.filter(item=>{if(item.category!==p.category||seen.has(item.handle)||!variants(item).length)return false;seen.add(item.handle);return true;}).sort((a,b)=>Number(Boolean(b.image))-Number(Boolean(a.image))).slice(0,3);}
 function renderRelatedProducts(p){const items=relatedProducts(p),wrap=q('[data-related]'),container=q('[data-related-grid]');container.replaceChildren();wrap.hidden=!items.length;q('[data-related-category]').textContent=p.category;items.forEach(item=>{const button=text('button','','rt-related-item');button.type='button';button.setAttribute('aria-label',t('related_open')+' — '+item.title);const art=text('span','','rt-related-art');imageFor(item,art);button.append(art,text('strong',item.title));const arrow=text('span','↗','rt-related-arrow');arrow.setAttribute('aria-hidden','true');button.append(arrow);button.addEventListener('click',()=>{openProduct(item,lastFocus);q('[data-modal-title]').focus();});container.append(button);});}
 function imageFor(p,container){container.replaceChildren();if(p.image&&p.image!=='none'){const image=document.createElement('img');const src=p.image.startsWith('theme:')?root.dataset['image'+p.image.slice(6,7).toUpperCase()+p.image.slice(7)]:p.image;image.src=src+(src.includes('?')?'&':'?')+'width=600';image.alt='';image.width=600;image.height=600;image.loading='lazy';image.addEventListener('error',()=>container.replaceChildren(text('div',p.title,'rt-card-symbol')),{once:true});container.append(image);}else container.append(text('div',p.title,'rt-card-symbol'));}
 function render(){const term=clean(search.value.trim()),match=filteredCatalogue();const order=q('[data-sort]').value;if(order!=='featured')match.sort((a,b)=>(order==='za'?-1:1)*a.title.localeCompare(b.title,'en',{sensitivity:'base'}));grid.replaceChildren();
 match.slice(0,visibleCount).forEach(p=>{const card=text('article','','rt-card');const art=text('div','','rt-card-visual');imageFor(p,art);art.append(text('span',p.category));card.append(art,text('h3',p.title));if(p.editorial?.intro)card.append(text('p',p.editorial.intro,'rt-card-description'));const n=forms(p).length,hasRetail=variants(p).filter(v=>!formFilter.value||catalogueFormType(v.form)===formFilter.value).some(canRetail),label=wholesale?'choose_form':'choose_bag';card.append(text('p',n+' '+t(n===1?'form':'forms')+' · '+t(p.food_bag_sizes===false?'ask_options':'bag_range'),'rt-card-info'));if(formFilter.value){const matching=matchingCatalogueForms(p).length;card.append(text('p',matching+' '+t(matching===1?'matching_form':'matching_forms'),'rt-card-match'));}const price=text('p',wholesale?t('quote_only'):hasRetail?t('from')+' '+money(minPrice(p,formFilter.value)):t('price_pending'),'rt-card-price');if(wholesale||hasRetail)price.append(text('span',wholesale?t('for_business'):t('per_bag')));card.append(price);const button=text('button',t(label));button.type='button';button.setAttribute('aria-label',t(label)+' — '+p.title);button.append(text('span','↗'));button.lastChild.setAttribute('aria-hidden','true');button.addEventListener('click',()=>{const match=variants(p).find(v=>!formFilter.value||catalogueFormType(v.form)===formFilter.value);openProduct(p,button,match?.catalogue_id,match?.form);});card.append(button);grid.append(card)});
 const count=t('showing')+' '+Math.min(visibleCount,match.length)+' '+t('of')+' '+match.length+' '+t(match.length===1?'product_count':'products_count');q('[data-count]').textContent=count+' · '+t(wholesale?'wholesale_mode':'retail_mode');q('[data-page-count]').textContent=count;q('[data-load-more-wrap]').hidden=visibleCount>=match.length;q('[data-empty]').hidden=match.length>0;q('[data-clear]').hidden=!term&&!category.value&&!formFilter.value&&order==='featured';updateFormCounts();renderFilterChips();if(!match.length)renderEmptyResults();qs('[data-pick-category]').forEach(a=>{if(a.dataset.pickCategory===category.value)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});
 }
 function chosen(){return selected&&variants(selected).find(v=>v.form===q('[data-form]').value&&(wholesale||v.size===q('[data-size]').value))}
 function updateDetail(){const v=chosen(),buyable=!wholesale&&canRetail(v);q('[data-modal-price]').textContent=wholesale?t('quote_only'):buyable?money(v.price_cents):t('price_pending');q('[data-modal-note]').textContent=wholesale?t('quote_note'):buyable?(preview?t('preview_price_note'):t('live_price_note')):t('retail_pending_note');const action=q('[data-add]');action.textContent=wholesale?t('list_direct'):buyable?(preview?t('preview_add'):v?.available?t('add_basket'):t('unavailable')):t('unavailable');action.disabled=!wholesale&&(!buyable||(!preview&&!v?.available));imageFor({...selected,image:v?.image||''},q('[data-modal-art]'));q('[data-origin-wrap]').hidden=!v?.origin;q('[data-origin]').textContent=v?.origin||'';q('[data-ingredient-link]').href=ingredientUrl(selected,v).href;const question=q('[data-retail-question]');if(question){question.hidden=wholesale;if(!wholesale)question.href=retailQuestionUrl(selected,v);}if(detail.open)syncIngredientUrl();if(wholesale){const list=q('[data-rs-selection-add]');list.dataset.defaultVariant=v?.catalogue_id||'';q('[data-trade-actions]').hidden=!document.querySelector('[data-rs-selection-root]');document.dispatchEvent(new CustomEvent('rs:selection-controls-update'));}}

 function openProduct(p,button,formId,formName){selected=p;lastFocus=button||search;renderIngredientNotes(p);renderRelatedProducts(p);q('[data-modal-title]').textContent=p.title;q('[data-modal-category]').textContent=p.category;imageFor(p,q('[data-modal-art]'));const form=q('[data-form]');form.replaceChildren();forms(p).forEach(f=>{const o=text('option',f);o.value=f;form.append(o)});const requested=(formId?variants(p).find(v=>v.catalogue_id===formId):null)||(formName?variants(p).find(v=>v.form===formName):null);if(requested)form.value=requested.form;if(!wholesale){setSizes();q('[data-quantity]').value='1';}updateDetail();detail.showModal();detail.scrollTop=0;syncIngredientUrl();q('[data-detail-close]').focus();}
 function setSizes(){const size=q('[data-size]'),old=size.value;size.replaceChildren();variants(selected).filter(v=>v.form===q('[data-form]').value).forEach(v=>{const o=text('option',v.size);o.value=v.size;size.append(o)});if([...size.options].some(o=>o.value===old))size.value=old;}
 function close(dialog){dialog.close();if(dialog===detail)clearIngredientUrl();if(lastFocus?.isConnected)lastFocus.focus();}
 function announce(message){q('[data-live]').textContent=message;q('[data-live]').hidden=false;setTimeout(()=>{q('[data-live]').hidden=true},4000);}
 function basketRender(){q('[data-basket-count]').textContent=basket.reduce((n,l)=>n+l.quantity,0);const container=q('[data-basket-lines]');container.replaceChildren();basket.forEach((line,i)=>{const row=text('div','','rt-basket-line'),left=document.createElement('div');left.append(text('strong',line.title),text('small',line.form+' · '+line.size+' × '+line.quantity));const remove=text('button',t('remove'));remove.type='button';remove.setAttribute('aria-label',t('remove')+' '+line.title+' '+line.size);remove.addEventListener('click',()=>{basket.splice(i,1);basketRender()});left.append(remove);row.append(left,text('strong',money(line.price_cents*line.quantity)));container.append(row)});q('[data-total]').textContent=money(basket.reduce((n,l)=>n+l.price_cents*l.quantity,0));q('[data-basket-empty]').hidden=basket.length>0;}
 q('[data-add]').addEventListener('click',async()=>{const v=chosen();if(wholesale){location.href=quoteUrl(selected,v||variants(selected)[0]);return;}if(!canRetail(v))return;const qty=q('[data-quantity]');if(!qty.checkValidity()){qty.reportValidity();return;}const quantity=Number(qty.value);if(!v||!Number.isInteger(quantity)||quantity<1||quantity>999)return;
 if(preview){const key=selected.handle+'|'+v.form+'|'+v.size;const line=basket.find(l=>l.key===key);if(line)line.quantity=Math.min(999,line.quantity+quantity);else basket.push({...v,key,title:selected.title,quantity});basketRender();close(detail);announce(t('added'));return;}
 if(!native||!v.id||!v.available||v.price_cents<=0)return;const button=q('[data-add]');button.disabled=true;
 try{const response=await fetch((root.dataset.cartAddUrl||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(v.id),quantity}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||t('add_error'));location.href=root.dataset.cartUrl||'/cart';}catch(error){announce(error.message||t('add_error'));button.disabled=false;}
 });
 q('[data-form]').addEventListener('change',()=>{if(!wholesale)setSizes();updateDetail()});q('[data-size]')?.addEventListener('change',updateDetail);q('[data-detail-close]').addEventListener('click',()=>close(detail));q('[data-basket-close]')?.addEventListener('click',()=>close(basketDialog));q('[data-continue-shopping]')?.addEventListener('click',()=>close(basketDialog));q('[data-open-basket]')?.addEventListener('click',e=>{if(!preview){location.href=root.dataset.cartUrl||'/cart';return;}lastFocus=e.currentTarget;basketRender();basketDialog.showModal();q('[data-basket-close]').focus()});
 q('[data-list-add]')?.addEventListener('click',()=>close(detail));q('[data-list-review]')?.addEventListener('click',()=>close(detail));
 [detail,basketDialog].filter(Boolean).forEach(d=>d.addEventListener('cancel',()=>{if(d===detail)clearIngredientUrl();if(lastFocus?.isConnected)lastFocus.focus()}));
 function filterChanged(){visibleCount=24;render();const url=new URL(location.href);for(const [key,value] of [['q',search.value.trim()],['category',category.value],['form_type',formFilter.value],['sort',q('[data-sort]').value==='featured'?'':q('[data-sort]').value]]){if(value)url.searchParams.set(key,value);else url.searchParams.delete(key);}history.replaceState(null,'',url);}
 search.addEventListener('input',filterChanged);category.addEventListener('change',filterChanged);formFilter.addEventListener('change',filterChanged);q('[data-sort]').addEventListener('change',filterChanged);q('[data-clear]').addEventListener('click',resetCatalogue);q('[data-empty-reset]').addEventListener('click',resetCatalogue);qs('[data-pick-category]').forEach(a=>a.addEventListener('click',()=>{search.value='';category.value=a.dataset.pickCategory;formFilter.value='';filterChanged()}));q('[data-load-more]').addEventListener('click',()=>{const old=visibleCount;visibleCount+=24;render();grid.children[old]?.querySelector('button')?.focus();});
 async function init(){try{const response=await fetch(root.dataset.catalogueUrl);if(!response.ok)throw Error(t('load_error'));const data=await response.json();products=data.products;
 if(native){const active=JSON.parse(q('[data-native-products]').textContent);active.forEach(p=>{const i=products.findIndex(base=>base.handle===p.handle);if(i<0){products.push(p);return;}const base=products[i];products[i]={...base,...p,image:p.image||base.image,aliases:base.aliases,variants:p.variants};});}
 const cats=[...new Set(products.map(p=>p.category))];cats.forEach(c=>{const option=text('option',c);option.value=c;category.append(option)});populateFormFilters();const params=new URLSearchParams(location.search);if([...formFilter.options].some(option=>option.value===params.get('form_type')))formFilter.value=params.get('form_type');if(cats.includes(params.get('category')))category.value=params.get('category');if(params.get('q'))search.value=params.get('q');if(['az','za'].includes(params.get('sort')))q('[data-sort]').value=params.get('sort');render();q('[data-loading]').hidden=true;if(!wholesale&&!preview&&!native){q('[data-retail-launch]').hidden=false;q('[data-open-basket]').hidden=true;}const linked=products.find(p=>p.handle===params.get('ingredient'));if(linked)openProduct(linked,search,params.get('form'));}catch(e){q('[data-loading]').textContent=t('load_error');}}
 init();
});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-wholesale-range"] && !Shopify.designMode) return;
  try {
    
(()=>{
const roots=document.querySelectorAll('[data-retail-studio]');
roots.forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const q=s=>root.querySelector(s), qs=s=>[...root.querySelectorAll(s)], dictionary=JSON.parse(q('[data-copy]').textContent), t=k=>String(dictionary[k]||k).replace(/&(amp|lt|gt|quot|#39|#x27);/g,(_,entity)=>({amp:'&',lt:'<',gt:'>',quot:'"','#39':"'",'#x27':"'"}[entity]));
 const wholesale=root.dataset.channel==='wholesale', preview=!wholesale&&root.dataset.preview==='true', native=!wholesale&&root.dataset.native==='true';
 let products=[],basket=[],selected=null,lastFocus=null,visibleCount=24;
 const grid=q('[data-grid]'), search=q('[data-search]'), category=q('[data-category]'), formFilter=q('[data-form-filter]'), detail=q('[data-product-dialog]'), basketDialog=q('[data-basket-dialog]');
 const text=(tag,value,cls)=>{let e=document.createElement(tag);e.textContent=value;if(cls)e.className=cls;return e};
 const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(cents/100);
 const clean=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
 function matchesCatalogueQuery(value,query){const words=value=>clean(value).match(/[\p{L}\p{N}]+(?:[./][\p{L}\p{N}]+)*/gu)||[];const source=words(value),terms=words(query);return !query.trim()||(terms.length>0&&terms.every(term=>source.some(word=>word.startsWith(term))));}
 const variants=p=>p.variants||[];
 const canRetail=v=>Boolean(v&&v.price_cents>0&&!v.quote_only&&(preview||(native&&v.id)));
 const minPrice=(p,type='')=>Math.min(...variants(p).filter(v=>!type||catalogueFormType(v.form)===type).map(v=>v.price_cents).filter(n=>n>0));
 const forms=p=>[...new Set(variants(p).map(v=>v.form))];
 const formFacets=[{key:'whole',test:/\bwhole\b/},{key:'ground',test:/\b(?:ground|powder|flour)\b/},{key:'crushed',test:/\b(?:cracked|crushed|flakes)\b/},{key:'cut',test:/\b(?:cut|chopped|minced|diced|shredded)\b/},{key:'granulated',test:/\bgranulated\b/},{key:'blends',test:/\bblend\b/},{key:'other',test:null}];
 function catalogueFormType(value){return formFacets.find(facet=>facet.test?.test(clean(value||'')))?.key||'other';}
 function catalogueState(overrides={}){return {query:search.value.trim(),category:category.value,formType:formFilter.value,...overrides};}
 function catalogueMatches(p,state=catalogueState()){return (!state.category||p.category===state.category)&&(!state.formType||variants(p).some(v=>catalogueFormType(v.form)===state.formType))&&matchesCatalogueQuery([p.title,...(p.aliases||[]),...forms(p)].join(' '),state.query);}
 function filteredCatalogue(overrides={}){const state=catalogueState(overrides);return products.filter(p=>catalogueMatches(p,state));}
 function matchingCatalogueForms(p){return [...new Set(variants(p).filter(v=>!formFilter.value||catalogueFormType(v.form)===formFilter.value).map(v=>v.form))];}
 function populateFormFilters(){formFilter.replaceChildren(text('option',t('form_filter_all')));formFilter.firstChild.value='';formFacets.filter(facet=>products.some(p=>variants(p).some(v=>catalogueFormType(v.form)===facet.key))).forEach(facet=>{const option=text('option',t('form_filter_'+facet.key));option.value=facet.key;formFilter.append(option);});formFilter.disabled=false;}
 function updateFormCounts(){[...formFilter.options].forEach(option=>{if(!option.value)return;const count=filteredCatalogue({formType:option.value}).length;option.textContent=t('form_filter_'+option.value)+' ('+count+')';option.disabled=count===0&&option.value!==formFilter.value;});}
 function renderFilterChips(){const wrap=q('[data-active-filters]'),list=q('[data-filter-chips]');list.replaceChildren();const filters=[{key:'query',value:search.value.trim(),label:t('filter_chip_search'),field:search},{key:'category',value:category.value,label:t('filter_chip_category'),field:category},{key:'formType',value:formFilter.value?t('form_filter_'+formFilter.value):'',label:t('filter_chip_form'),field:formFilter}].filter(filter=>filter.value);filters.forEach((filter,index)=>{const item=text('li',''),button=text('button','','rt-filter-chip'),label=filter.label+': '+filter.value;button.type='button';button.dataset.filterKey=filter.key;button.setAttribute('aria-label',t('filter_remove').replace('{filter}',label));button.append(text('span',label));const cross=text('span','×');cross.setAttribute('aria-hidden','true');button.append(cross);button.addEventListener('click',()=>{filter.field.value='';filterChanged();const next=list.querySelectorAll('button');(next[Math.min(index,next.length-1)]||filter.field).focus();});item.append(button);list.append(item);});wrap.hidden=!filters.length;}
 function catalogueBrowseUrl(overrides={}){const state=catalogueState(overrides),url=new URL(location.href);for(const [key,value] of [['q',state.query],['category',state.category],['form_type',state.formType],['sort','az']]){if(value)url.searchParams.set(key,value);else url.searchParams.delete(key);}url.searchParams.delete('ingredient');url.searchParams.delete('form');url.hash=q('[data-catalogue-section]').id;return url.href;}
 function renderEmptyResults(){const query=search.value.trim(),message=query?t('empty_search_message').replace('{query}',query):t('empty_filter_message');q('[data-empty-message]').textContent=message;const broader=q('[data-empty-broaden]'),withoutForm=filteredCatalogue({formType:''});broader.hidden=!formFilter.value||!withoutForm.length;if(!broader.hidden){broader.href=catalogueBrowseUrl({formType:''});broader.textContent=t('empty_all_forms')+' ('+withoutForm.length+')';}const matchingElsewhere=filteredCatalogue({category:''}),preserve=matchingElsewhere.length>0,candidates=preserve?matchingElsewhere:products,counts=new Map();candidates.forEach(p=>counts.set(p.category,(counts.get(p.category)||0)+1));const entries=[...counts].sort((a,b)=>(!preserve?Number(b[0]===category.value)-Number(a[0]===category.value):0)||b[1]-a[1]||a[0].localeCompare(b[0])).slice(0,3),paths=q('[data-empty-paths]');paths.replaceChildren();entries.forEach(([name,count])=>{const link=text('a','','rt-empty-path');link.href=catalogueBrowseUrl({category:name,...(preserve?{}:{query:'',formType:''})});const copy=text('span','');copy.append(text('strong',name),text('small',count+' '+t(count===1?'product_count':'products_count')));const arrow=text('span','↗');arrow.setAttribute('aria-hidden','true');link.append(copy,arrow);paths.append(link);});}
 function resetCatalogue(){search.value='';category.value='';formFilter.value='';q('[data-sort]').value='featured';filterChanged();search.focus();}

 function quoteUrl(p,v){if(wholesale&&v?.catalogue_id){const url=new URL(root.dataset.requestUrl||'/pages/wholesale-request',location.origin);url.searchParams.set('list_items',v.catalogue_id);return url.href;}const url=new URL(root.dataset.quoteUrl||'/pages/contact',location.origin);url.searchParams.set('product',p.title);if(v?.form&&!v.form.startsWith('Ask about'))url.searchParams.set('variant',v.form);return url.href;}
 function retailQuestionUrl(p,v){const url=new URL(root.dataset.quoteUrl||'/pages/contact',location.origin),source=new URL('/pages/retail-shop',url.origin);url.search='';url.searchParams.set('enquiry_type','retail');url.searchParams.set('product',p.title);if(v?.form&&!v.form.startsWith('Ask about'))url.searchParams.set('variant',v.form);source.searchParams.set('ingredient',p.handle);if(v?.catalogue_id)source.searchParams.set('form',v.catalogue_id);url.searchParams.set('product_url',source.href);return url.href;}
 function ingredientUrl(p,v){const url=new URL(location.href);url.searchParams.set('ingredient',p.handle);if(v?.catalogue_id)url.searchParams.set('form',v.catalogue_id);else url.searchParams.delete('form');return url;}
 function syncIngredientUrl(){if(selected)history.replaceState(null,'',ingredientUrl(selected,chosen()));}
 function clearIngredientUrl(){const url=new URL(location.href);url.searchParams.delete('ingredient');url.searchParams.delete('form');history.replaceState(null,'',url);}
 function renderIngredientNotes(p){const copy=p.editorial||{},ideas=Array.isArray(copy.use_ideas)?copy.use_ideas:[];q('[data-modal-intro]').textContent=copy.intro||'';q('[data-modal-intro]').hidden=!copy.intro;q('[data-use-ideas]').replaceChildren(...ideas.map(idea=>text('li',idea)));q('[data-ideas-wrap]').hidden=!ideas.length;q('[data-buying-wrap]').hidden=!wholesale||!copy.buying_note;q('[data-buying-note]').textContent=copy.buying_note||'';q('[data-ingredient-notes]').hidden=!ideas.length&&(!wholesale||!copy.buying_note);qs('[data-ingredient-notes] details').forEach(d=>d.open=wholesale?d.hasAttribute('data-buying-wrap'):d.hasAttribute('data-ideas-wrap'));const guide=q('[data-guide-link]');guide.hidden=!copy.guide_path;if(copy.guide_path?.startsWith('/pages/'))guide.href=new URL(copy.guide_path,new URL(root.dataset.quoteUrl||'/pages/contact',location.origin)).href;else guide.hidden=true;renderPairingLinks(p);}
 function renderPairingLinks(p){const wrap=q('[data-pairing-inspiration]'),list=q('[data-pairing-links]'),seen=new Set(),items=Array.isArray(p.editorial?.pairings)?p.editorial.pairings:[];list.replaceChildren();items.forEach(item=>{if(!item||typeof item.title!=='string'||!item.title.trim()||typeof item.path!=='string'||!/^\/pages\/spice-pairings#Pairing-[a-z-]+$/.test(item.path)||seen.has(item.path))return;seen.add(item.path);const link=text('a',item.title);link.href=new URL(item.path,new URL(root.dataset.quoteUrl||'/pages/contact',location.origin)).href;const arrow=text('span','↗');arrow.setAttribute('aria-hidden','true');link.append(arrow);list.append(link);});wrap.hidden=!list.children.length;}
 function relatedProducts(p){const seen=new Set([p.handle]);return products.filter(item=>{if(item.category!==p.category||seen.has(item.handle)||!variants(item).length)return false;seen.add(item.handle);return true;}).sort((a,b)=>Number(Boolean(b.image))-Number(Boolean(a.image))).slice(0,3);}
 function renderRelatedProducts(p){const items=relatedProducts(p),wrap=q('[data-related]'),container=q('[data-related-grid]');container.replaceChildren();wrap.hidden=!items.length;q('[data-related-category]').textContent=p.category;items.forEach(item=>{const button=text('button','','rt-related-item');button.type='button';button.setAttribute('aria-label',t('related_open')+' — '+item.title);const art=text('span','','rt-related-art');imageFor(item,art);button.append(art,text('strong',item.title));const arrow=text('span','↗','rt-related-arrow');arrow.setAttribute('aria-hidden','true');button.append(arrow);button.addEventListener('click',()=>{openProduct(item,lastFocus);q('[data-modal-title]').focus();});container.append(button);});}
 function imageFor(p,container){container.replaceChildren();if(p.image&&p.image!=='none'){const image=document.createElement('img');const src=p.image.startsWith('theme:')?root.dataset['image'+p.image.slice(6,7).toUpperCase()+p.image.slice(7)]:p.image;image.src=src+(src.includes('?')?'&':'?')+'width=600';image.alt='';image.width=600;image.height=600;image.loading='lazy';image.addEventListener('error',()=>container.replaceChildren(text('div',p.title,'rt-card-symbol')),{once:true});container.append(image);}else container.append(text('div',p.title,'rt-card-symbol'));}
 function render(){const term=clean(search.value.trim()),match=filteredCatalogue();const order=q('[data-sort]').value;if(order!=='featured')match.sort((a,b)=>(order==='za'?-1:1)*a.title.localeCompare(b.title,'en',{sensitivity:'base'}));grid.replaceChildren();
 match.slice(0,visibleCount).forEach(p=>{const card=text('article','','rt-card');const art=text('div','','rt-card-visual');imageFor(p,art);art.append(text('span',p.category));card.append(art,text('h3',p.title));if(p.editorial?.intro)card.append(text('p',p.editorial.intro,'rt-card-description'));const n=forms(p).length,hasRetail=variants(p).filter(v=>!formFilter.value||catalogueFormType(v.form)===formFilter.value).some(canRetail),label=wholesale?'choose_form':'choose_bag';card.append(text('p',n+' '+t(n===1?'form':'forms')+' · '+t(p.food_bag_sizes===false?'ask_options':'bag_range'),'rt-card-info'));if(formFilter.value){const matching=matchingCatalogueForms(p).length;card.append(text('p',matching+' '+t(matching===1?'matching_form':'matching_forms'),'rt-card-match'));}const price=text('p',wholesale?t('quote_only'):hasRetail?t('from')+' '+money(minPrice(p,formFilter.value)):t('price_pending'),'rt-card-price');if(wholesale||hasRetail)price.append(text('span',wholesale?t('for_business'):t('per_bag')));card.append(price);const button=text('button',t(label));button.type='button';button.setAttribute('aria-label',t(label)+' — '+p.title);button.append(text('span','↗'));button.lastChild.setAttribute('aria-hidden','true');button.addEventListener('click',()=>{const match=variants(p).find(v=>!formFilter.value||catalogueFormType(v.form)===formFilter.value);openProduct(p,button,match?.catalogue_id,match?.form);});card.append(button);grid.append(card)});
 const count=t('showing')+' '+Math.min(visibleCount,match.length)+' '+t('of')+' '+match.length+' '+t(match.length===1?'product_count':'products_count');q('[data-count]').textContent=count+' · '+t(wholesale?'wholesale_mode':'retail_mode');q('[data-page-count]').textContent=count;q('[data-load-more-wrap]').hidden=visibleCount>=match.length;q('[data-empty]').hidden=match.length>0;q('[data-clear]').hidden=!term&&!category.value&&!formFilter.value&&order==='featured';updateFormCounts();renderFilterChips();if(!match.length)renderEmptyResults();qs('[data-pick-category]').forEach(a=>{if(a.dataset.pickCategory===category.value)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});
 }
 function chosen(){return selected&&variants(selected).find(v=>v.form===q('[data-form]').value&&(wholesale||v.size===q('[data-size]').value))}
 function updateDetail(){const v=chosen(),buyable=!wholesale&&canRetail(v);q('[data-modal-price]').textContent=wholesale?t('quote_only'):buyable?money(v.price_cents):t('price_pending');q('[data-modal-note]').textContent=wholesale?t('quote_note'):buyable?(preview?t('preview_price_note'):t('live_price_note')):t('retail_pending_note');const action=q('[data-add]');action.textContent=wholesale?t('list_direct'):buyable?(preview?t('preview_add'):v?.available?t('add_basket'):t('unavailable')):t('unavailable');action.disabled=!wholesale&&(!buyable||(!preview&&!v?.available));imageFor({...selected,image:v?.image||''},q('[data-modal-art]'));q('[data-origin-wrap]').hidden=!v?.origin;q('[data-origin]').textContent=v?.origin||'';q('[data-ingredient-link]').href=ingredientUrl(selected,v).href;const question=q('[data-retail-question]');if(question){question.hidden=wholesale;if(!wholesale)question.href=retailQuestionUrl(selected,v);}if(detail.open)syncIngredientUrl();if(wholesale){const list=q('[data-rs-selection-add]');list.dataset.defaultVariant=v?.catalogue_id||'';q('[data-trade-actions]').hidden=!document.querySelector('[data-rs-selection-root]');document.dispatchEvent(new CustomEvent('rs:selection-controls-update'));}}

 function openProduct(p,button,formId,formName){selected=p;lastFocus=button||search;renderIngredientNotes(p);renderRelatedProducts(p);q('[data-modal-title]').textContent=p.title;q('[data-modal-category]').textContent=p.category;imageFor(p,q('[data-modal-art]'));const form=q('[data-form]');form.replaceChildren();forms(p).forEach(f=>{const o=text('option',f);o.value=f;form.append(o)});const requested=(formId?variants(p).find(v=>v.catalogue_id===formId):null)||(formName?variants(p).find(v=>v.form===formName):null);if(requested)form.value=requested.form;if(!wholesale){setSizes();q('[data-quantity]').value='1';}updateDetail();detail.showModal();detail.scrollTop=0;syncIngredientUrl();q('[data-detail-close]').focus();}
 function setSizes(){const size=q('[data-size]'),old=size.value;size.replaceChildren();variants(selected).filter(v=>v.form===q('[data-form]').value).forEach(v=>{const o=text('option',v.size);o.value=v.size;size.append(o)});if([...size.options].some(o=>o.value===old))size.value=old;}
 function close(dialog){dialog.close();if(dialog===detail)clearIngredientUrl();if(lastFocus?.isConnected)lastFocus.focus();}
 function announce(message){q('[data-live]').textContent=message;q('[data-live]').hidden=false;setTimeout(()=>{q('[data-live]').hidden=true},4000);}
 function basketRender(){q('[data-basket-count]').textContent=basket.reduce((n,l)=>n+l.quantity,0);const container=q('[data-basket-lines]');container.replaceChildren();basket.forEach((line,i)=>{const row=text('div','','rt-basket-line'),left=document.createElement('div');left.append(text('strong',line.title),text('small',line.form+' · '+line.size+' × '+line.quantity));const remove=text('button',t('remove'));remove.type='button';remove.setAttribute('aria-label',t('remove')+' '+line.title+' '+line.size);remove.addEventListener('click',()=>{basket.splice(i,1);basketRender()});left.append(remove);row.append(left,text('strong',money(line.price_cents*line.quantity)));container.append(row)});q('[data-total]').textContent=money(basket.reduce((n,l)=>n+l.price_cents*l.quantity,0));q('[data-basket-empty]').hidden=basket.length>0;}
 q('[data-add]').addEventListener('click',async()=>{const v=chosen();if(wholesale){location.href=quoteUrl(selected,v||variants(selected)[0]);return;}if(!canRetail(v))return;const qty=q('[data-quantity]');if(!qty.checkValidity()){qty.reportValidity();return;}const quantity=Number(qty.value);if(!v||!Number.isInteger(quantity)||quantity<1||quantity>999)return;
 if(preview){const key=selected.handle+'|'+v.form+'|'+v.size;const line=basket.find(l=>l.key===key);if(line)line.quantity=Math.min(999,line.quantity+quantity);else basket.push({...v,key,title:selected.title,quantity});basketRender();close(detail);announce(t('added'));return;}
 if(!native||!v.id||!v.available||v.price_cents<=0)return;const button=q('[data-add]');button.disabled=true;
 try{const response=await fetch((root.dataset.cartAddUrl||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(v.id),quantity}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||t('add_error'));location.href=root.dataset.cartUrl||'/cart';}catch(error){announce(error.message||t('add_error'));button.disabled=false;}
 });
 q('[data-form]').addEventListener('change',()=>{if(!wholesale)setSizes();updateDetail()});q('[data-size]')?.addEventListener('change',updateDetail);q('[data-detail-close]').addEventListener('click',()=>close(detail));q('[data-basket-close]')?.addEventListener('click',()=>close(basketDialog));q('[data-continue-shopping]')?.addEventListener('click',()=>close(basketDialog));q('[data-open-basket]')?.addEventListener('click',e=>{if(!preview){location.href=root.dataset.cartUrl||'/cart';return;}lastFocus=e.currentTarget;basketRender();basketDialog.showModal();q('[data-basket-close]').focus()});
 q('[data-list-add]')?.addEventListener('click',()=>close(detail));q('[data-list-review]')?.addEventListener('click',()=>close(detail));
 [detail,basketDialog].filter(Boolean).forEach(d=>d.addEventListener('cancel',()=>{if(d===detail)clearIngredientUrl();if(lastFocus?.isConnected)lastFocus.focus()}));
 function filterChanged(){visibleCount=24;render();const url=new URL(location.href);for(const [key,value] of [['q',search.value.trim()],['category',category.value],['form_type',formFilter.value],['sort',q('[data-sort]').value==='featured'?'':q('[data-sort]').value]]){if(value)url.searchParams.set(key,value);else url.searchParams.delete(key);}history.replaceState(null,'',url);}
 search.addEventListener('input',filterChanged);category.addEventListener('change',filterChanged);formFilter.addEventListener('change',filterChanged);q('[data-sort]').addEventListener('change',filterChanged);q('[data-clear]').addEventListener('click',resetCatalogue);q('[data-empty-reset]').addEventListener('click',resetCatalogue);qs('[data-pick-category]').forEach(a=>a.addEventListener('click',()=>{search.value='';category.value=a.dataset.pickCategory;formFilter.value='';filterChanged()}));q('[data-load-more]').addEventListener('click',()=>{const old=visibleCount;visibleCount+=24;render();grid.children[old]?.querySelector('button')?.focus();});
 async function init(){try{const response=await fetch(root.dataset.catalogueUrl);if(!response.ok)throw Error(t('load_error'));const data=await response.json();products=data.products;
 if(native){const active=JSON.parse(q('[data-native-products]').textContent);active.forEach(p=>{const i=products.findIndex(base=>base.handle===p.handle);if(i<0){products.push(p);return;}const base=products[i];products[i]={...base,...p,image:p.image||base.image,aliases:base.aliases,variants:p.variants};});}
 const cats=[...new Set(products.map(p=>p.category))];cats.forEach(c=>{const option=text('option',c);option.value=c;category.append(option)});populateFormFilters();const params=new URLSearchParams(location.search);if([...formFilter.options].some(option=>option.value===params.get('form_type')))formFilter.value=params.get('form_type');if(cats.includes(params.get('category')))category.value=params.get('category');if(params.get('q'))search.value=params.get('q');if(['az','za'].includes(params.get('sort')))q('[data-sort]').value=params.get('sort');render();q('[data-loading]').hidden=true;if(!wholesale&&!preview&&!native){q('[data-retail-launch]').hidden=false;q('[data-open-basket]').hidden=true;}const linked=products.find(p=>p.handle===params.get('ingredient'));if(linked)openProduct(linked,search,params.get('form'));}catch(e){q('[data-loading]').textContent=t('load_error');}}
 init();
});
})();


  } catch(e) { console.error(e); }
})();
})();
